import React from 'react'
import {HashRouter, Route, Routes} from 'react-router-dom'

import './styles/desktopStyles/style.css'
import './styles/mobileStyles/style.css'

import {INGRESO_ROUTE} from './config/routes'

import Ingreso from './components/ingreso.component'

interface Props{}

interface State{}

class App extends React.Component<Props, State>{
    render(){
        return(
            <HashRouter>
                <Routes>
                    <Route
                        path={INGRESO_ROUTE}
                        element={<Ingreso/>}
                    />
                </Routes>
            </HashRouter>
        )
    }
} 

export default App;